import CONSTANTS from './product/CONSTANTS';

import axiosGetFullProductJSON from './product/axiosGetFullProductJSON';
import getCurrentSelectedOptions from './product/getCurrentSelectedOptions';
import updatePrice from './product/updatePrice';
import { formatMoney } from '@shopify/theme-currency';
import updateVariantFormField from './product/updateVariantFormField';
import switchStockDisplay from './product/switchStockDisplay';
import getVariantFromVariantsAndOptions from './product/getVariantFromVariantsAndOptions';
import updateVariantUrl from './product/updateVariantUrl';
import getVariantImageUrl from './product/getVariantImageUrl';
import getSizedImage from './product/getSizedImage';
import quickOrderListForm from './products/quickOrderListForm';

const defaults = CONSTANTS;

/**
 *
 * option defaults from contants:
 * product_form_selector: "[data-product-form-pdp]"
 * product_option_select_selector: "[data-option-select]"
 * product_main_image_selector: "[data-main-product-image]"
 * product_variant_id_form_field: "[data-product-form] [name="id"]"
 * product_image_thumbs_selector: "[data-product-thumbnail-index]"
 * product_image_thumbs_attr: "data-product-thumbnail-index"
 * product_thumbnail_active_class: "active"
 * product_stock_wrapper_attr: "data-product-in-stock"
 * product_oos_text_attr: "data-oos-text"
 * product_in_stock_text_attr: "data-in-stock-text"
 * product_unavailable_text_attr: "data-unavailable-text"
 * product_form_submit_button_selector: "[data-product-form-submit]"
 * product_price_selector: "[data-product-price]"
 * product_compare_at_price_selector: "[data-product-compare-at-price]"
 */

export const productInit = async (options, productUpdatedCallBack = variant => variant) => {
  const opts = Object.assign({}, defaults, options);

  const productForms = document.querySelectorAll(opts.product_form_selector);

  if (productForms.length === 0) {
    quickOrderListForm();

    return false;
  }

  for (const [index, productForm] of productForms.entries()) {
    //get the data
    const getThisProductsJSON = axiosGetFullProductJSON(productForm.dataset.productForm);
    const productData = await getThisProductsJSON();

    //get all the elements
    const variantIdFormField = productForm.querySelector(opts.product_variant_id_form_field);
    const atcButton = document.querySelector(opts.product_form_submit_button_selector);
    const priceEls = productForm.querySelectorAll(opts.product_price_selector);
    const compareAtpriceEls = productForm.querySelectorAll(opts.product_compare_at_price_selector);
    const optionSelects = productForm.querySelectorAll(opts.product_option_select_selector);
    const stockMap = JSON.parse(productForm.getAttribute(opts.product_stock_map));
    const mainImage = document.querySelector(opts.product_main_image_selector);

    //configure up the functions
    const isSecondProduct = index > 0 ? true : false;
    const updateProductVariantFormField = updateVariantFormField(
      productForm,
      variantIdFormField,
      productData.handle,
      isSecondProduct
    );
    const updateProductPrice = updatePrice(priceEls, compareAtpriceEls, window.theme.moneyFormat);

    // document.querySelectorAll()

    const switchProductStockDisplay = switchStockDisplay({
      stockWrapper: productForm,
      stockWrapperAttr: opts.product_stock_wrapper_attr,
      atcButton,
      oosAttr: opts.product_oos_text_attr,
      inStockAttr: opts.product_in_stock_text_attr,
      unavailableAttr: opts.product_unavailable_text_attr,
      preOrderAttr: opts.product_pre_order_attr
    });

    const getAvailabilityFlag = variant => (variant ? stockMap[variant.id.toString()] : 'unavailable');

    const updateStockDisplay = variant => {
      const flag = getAvailabilityFlag(variant);
      switchProductStockDisplay(flag, false);
    };

    const updateVariantData = variant => {
      let unselectedOptions = 0;

      document.querySelectorAll(opts.product_option_select_selector).forEach(activeSelect => {
        if (activeSelect.value === 'Please Select') unselectedOptions++;
      });

      if (unselectedOptions === 2) {
        updateStockDisplay('');
      } else if (variant) {
        updateStockDisplay(variant);
      }

      updateVariantUrl(variant);
      updateProductPrice(variant);
      updateProductVariantFormField(variant);
      productUpdatedCallBack(variant, productData);
    };

    const onSelectChange = selects => event => {
      const currentOptions = getCurrentSelectedOptions(selects);
      const variant = getVariantFromVariantsAndOptions(productData.variants)(currentOptions);
      updateVariantData(variant);

      const coordCountElem = document.querySelector('.product-form-co-ord__number');
      const coordTotalElem = document.querySelector('.product-form-co-ord__price');

      if (coordCountElem !== null && coordTotalElem !== null) {
        let totalPrice = 0,
          itemCount = 0;
        const selectElems = document.querySelectorAll('.product-form-co-ord__wrapper [data-option-select]');

        for (const e of selectElems) {
          const price = parseFloat(e.options[e.selectedIndex].dataset.optionPrice);
          if (price) {
            totalPrice = totalPrice + price;
            itemCount++;
          }
        }
        // as you can now select the variants (even when OOS - for BIS puproses)
        // ensure that if at least 1 itemCount (price is 0 on OOS)
        // that the button is purchasable
        if (itemCount >= 1) {
          switchProductStockDisplay('available', true);
        }

        coordCountElem.innerHTML = itemCount;
        coordTotalElem.innerHTML = '';
        if (totalPrice > 0) coordTotalElem.innerHTML = formatMoney(totalPrice, window.theme.moneyFormat);

        if (event && event?.target) {
          const selectFormWrapper = event.target.closest('[data-product-form]');
          const bisFormWrapper = selectFormWrapper.querySelector('.back-in-stock');
          if (bisFormWrapper) {
            const bisForm = bisFormWrapper.querySelector('[data-bis-form]');
            const bisMessages = bisFormWrapper.querySelector('[data-notify-message]');
            bisMessages.classList.add('hide');
            if (event?.target?.value === 'Please Select') {
              bisForm.classList.add('hide');
            } else {
              bisForm.classList.remove('hide');
            }
          }
        }
      }

      if (!variant || !mainImage.dataset.giftCardImage) {
        return;
      }
      const imageUrl = getVariantImageUrl(variant);
      if (!imageUrl) {
        return;
      }
      const sizedImage = getSizedImage(imageUrl, opts.IMAGE_SIZE);
      mainImage.dataset.rawSrc = imageUrl;
      mainImage.src = sizedImage;
      document.querySelector('[data-property-gift-card-image]').value = sizedImage;
    };

    [...optionSelects].forEach(select => select.addEventListener('change', onSelectChange([...optionSelects])));

    onSelectChange([...optionSelects])();
  }
};
